"use strict";

(function (global) {
  /**
  * Функции отвечающие за работу контекстного меню.
  * @namespace Core.contextmenu
  * @since 5.1.0.1516
  */
  global.contextmenu = {};
})(window.Core);


(function (global) {

  var menusCache = {};
  var objKindMap = {
    'edoc': 'EDocument',
    'task': 'Task',
    'job': 'Job',
    'fol': 'Folder',
    'ref': 'ReferenceRecord',
    'usr': 'UserSettings',
    'ver': 'EDocumentVersion',
    'com': 'Common',
    'att': 'Attachments',
    'localcopy': 'LocalCopy',
    'current_fol': 'CurrentFolder'
  };


  /**
   * Показывает контекстное меню.
   *
   * @param {object} clickedEl Объект, по которому совершен клик.
   * @param {object} options Параметры.
   * @param {object} coords Координаты меню.
   * @param {boolean} isRightButton Признак нажатия правой кнопки мыши.
   */
  global.show = function (obj, options, coords, isRightButton) {
    if (obj instanceof jQuery || obj instanceof HTMLElement) {
      if (WA.CR && WA.CR.objectList) {
        var jClickedEl = $(obj);

        if (isRightButton) {
          selectClickedElementAndUnselectOther(jClickedEl);
        }

        var selectedItems = WA.CR.objectList.getSelectedItems();
        if (selectedItems.length > 1) {
          showContextMenuForManyObjects(selectedItems, jClickedEl, options, coords, isRightButton);
          // Что бы не вызвалось меню для одного элемента.
          return;
        }
      }
      showContextMenuForOneObject(obj, options, coords, isRightButton);
    } else {
      showForFolderTreeItem(obj, options, coords);
    }
  };

  function showContextMenuForManyObjects(selectedItems, jClickedEl, options, coords, isRightButton) {
    var types = _.chain(selectedItems).pluck('type').uniq().value();
    var menuType = 'Mass' + types.join('');

    var resultMenuItems = getMassMenuItemsByTypes(types);
    if (resultMenuItems.length === 0) return;

    _toggleMarkAsReadMenuItemText(resultMenuItems, selectedItems);

    var menu = getOrAddContextMenuFormCache(menuType, resultMenuItems, { width: 212 });
    if (!menu) return;
    // Передаем в контекстное меню список выбранных элементов.
    setMenuProperties(menu, { context: selectedItems });

    var hasStatusBar = _.every(selectedItems, function (item) { return item._jObject.find('div.status').length > 0; });
    if (hasStatusBar) {
      // Показываем горизонтальное меню статусов.
      window.Core.toolBars.main.showHorizontalStatusContextMenu(menu, jClickedEl, selectedItems, isRightButton);
    }
    showContextMenuInternal(menu, jClickedEl, coords);
  };

  // Изменяет текст пункта меню "Пометить прочитанным" в зависимости от выбранных заданий.
  function _toggleMarkAsReadMenuItemText(resultMenuItems, selectedItems) {
    var markAsReadMenuItem = _.first(_.filter(resultMenuItems, function (item) { return item.id === 'MarkAsRead' }));

    if (markAsReadMenuItem) {
      var jobs = _.filter(selectedItems, function (item) { return item.type === OBJECT_TYPE.JOB });
      if (jobs.length > 0) {
        if (_.filter(jobs, function (job) { return job.isUnread() }).length === 0) {
          markAsReadMenuItem.text = 'MENU_MARK_AS_UNREAD';
        } else {
          markAsReadMenuItem.text = 'MENU_MARK_AS_READ';
        }
      }
    }
  };

  // Создает объект контекстного меню.
  function build(options) {
    var menu = getOrAddContextMenuFormCache(options.objectType);
    if (menu) {
      // Изменить доступность пунктов меню.
      enableItem('CreateSubTask', menu);
      enableItem('CopyDoc', menu);
      if (options.cannotDelete) {
        disableItem('DeleteLink', menu);
      } else {
        enableItem('DeleteLink', menu);
      }
    };
    setDefaultItem(menu, options.defaultItem);

    setMenuProperties(menu, {
      context: options.proxy,
      onHide: options.onHide
    });

    return menu;
  };


  function showContextMenuForOneObject(obj, options, coords, isRightButton) {
    var el = $(obj);
    var listItem = el.parents('.List:first');
    var tr = listItem.length > 0 ? listItem : el;
    var proxy;

    var menuOptions = {};

    if (options && options.from === 'ReferenceTable') {
      proxy = { id: tr.data('recid'), kind: 'ref', refcode: Reference_GetName(), elem: el, tr: tr };
      menuOptions.objectType = 'ReferenceRecordTable';
    } else {
      proxy = GetObjectInfoFromRow(tr);
    }
    $.extend(proxy, options);

    menuOptions.proxy = proxy;
    if (!menuOptions.objectType) {
      menuOptions.objectType = objKindMap[proxy.kind.toLowerCase()];

      if (!proxy.kind) {
        return;
      } else if (proxy.kind.toLowerCase() === 'current_fol') {
        proxy.kind = 'fol';
      }
    }

    if (menuOptions.objectType === 'ReferenceRecord' || menuOptions.objectType === 'ReferenceRecordTable') {
      var refName = Reference_GetName();
      var refView = Reference_GetView();
      var specObjType = [
        menuOptions.objectType + '_' + refName,
        menuOptions.objectType + '_' + refView,
        menuOptions.objectType + '_' + refName + '_' + refView
      ];
      for (var i = 0, specObjTypeLen = specObjType.length; i < specObjTypeLen; i++) {
        if (contextMenuSettings[specObjType[i]]) {
          menuOptions.objectType = specObjType[i];
        }
      }
    }
    proxy.type = menuOptions.objectType;

    const taskChangeButton = window.WA.CR.toolBar.buttons.TaskChange;
    const isTaskReadOnlyMode = window.WA.getLocation() === 'task' && taskChangeButton && !taskChangeButton.isSelected();
    menuOptions.cannotDelete = !!(tr.hasClass('cannot_delete') || isTaskReadOnlyMode);
    if (menuOptions.objectType === 'EDocumentVersion') {
      menuOptions.defaultItem = (g_defaultListAction === 'showcard' || g_defaultListAction === 'preview')
        ? 'Preview'
        : (g_openDocForEditByDefault ? 'OpenForEdit' : 'ViewInEditor');
    }

    if (menuOptions.objectType === 'EDocument') {
      switch (g_defaultListAction) {
        case 'showcard':
          menuOptions.defaultItem = 'Card';
          break;
        case 'preview':
          menuOptions.defaultItem = 'Preview';
          break;
        case 'open':
          menuOptions.defaultItem = 'OpenForEdit';
          break;
        case 'viewineditor':
          menuOptions.defaultItem = 'ViewInEditor';
          break;
        default:
      }
    }

    if (menuOptions.objectType === 'Task' || menuOptions.objectType === 'Job' || menuOptions.objectType === 'Folder') {
      menuOptions.defaultItem = '';
    } else if (menuOptions.objectType === 'Attachments' || menuOptions.objectType === 'Common') {
      menuOptions.defaultItem = 'no';
    }


    if (!el.hasClass('menuicon_border')) {
      ContextMenu.hide();
      menuOptions.onHide = function () {
        var jListParent = $('body');
        jListParent.find('.menuicon_border').removeClass('menuicon_border');
        jListParent.find('.menu_select').removeClass('menu_select');
      };

      if (!isRightButton) {
        el.addClass('menuicon_border');
      }
      tr.addClass('menu_select');

      var menu = build(menuOptions);

      var hasStatusBar = tr.find('div.status').length > 0;
      if ((menuOptions.objectType === 'EDocument' || menuOptions.objectType === 'Task'
          || menuOptions.objectType === 'Job' || menuOptions.objectType === 'Folder')
          && hasStatusBar) {
        // Показываем горизонтальное меню статусов.
        window.Core.toolBars.main.showHorizontalStatusContextMenu(menu, el, proxy, isRightButton);
      }

      setTimeout(function () { //Для того, что бы контекстное меню для свободной области проводника сразу НЕ скрывалось после отображения.
        switch (menuOptions.objectType) {
          case 'EDocument':
            EDocument(proxy).GetContextMenu(menu, function () { showContextMenuInternal(menu, el, coords); });
            break;
          case 'EDocumentVersion':
            EDocumentVersion(proxy).GetContextMenu(menu, function () { showContextMenuInternal(menu, el, coords); });
            break;
          case 'ReferenceRecordTable':
            showReferenceContextMenu(menu, el, coords);
            break;
          default:
            showContextMenuInternal(menu, el, coords);
        }
      }, 10);
    }
    else {
      ContextMenu.hide();
    }
  };

  function showForFolderTreeItem(node, options, coords) {
    var objType = node.kind === 'COMPONENT_TOKEN' ? '' : 'fol';

    var menuOptions = {};
    menuOptions.objectType = objKindMap[objType];

    if (objType) {
      menuOptions.proxy = options;
      menuOptions.defaultItem = '';

      ContextMenu.hide();
      var menu = build(menuOptions);
      showContextMenuInternal(menu, null, coords);
    }
  };

  // Получает (или добавляет, если нет) компоненту контекстного меню из кэша.
  function getOrAddContextMenuFormCache(objType, items, settings) {
    if (!menusCache.hasOwnProperty(objType)) {
      var menuItems = items;
      var menuSettings = settings || {};

      if (!menuItems) {
        var settings = contextMenuSettings[objType];
        if (!settings) return null;
        menuItems = settings.items.slice(0); //Клонируем массив, чтобы сохранить его в первозданном виде.

        // Удаляем пункт "Вырезать ссылку" везде кроме папки.
        if (location.href.toLowerCase().indexOf('explorer.aspx') == -1) {
          menuItems = deleteItemById(menuItems, 'CutLink');
        };

        menuSettings = settings.settings;
      }

      menusCache[objType] = new ContextMenu(menuItems, menuSettings);
    }

    if (menusCache.hasOwnProperty('EDocument')) {
      updateContextMenu('EDocument');
    }
    if (menusCache.hasOwnProperty('EDocumentVersion')) {
      updateContextMenu('EDocumentVersion');
    }
    if (menusCache.hasOwnProperty('Task')) {
      updateContextMenu('Task');
    }
    if (menusCache.hasOwnProperty('Job')) {
      updateContextMenu('Job');
    }
    return menusCache[objType];
  };

  // устанавливает свойства контекстного меню.
  function setMenuProperties(menu, props) {
    menu.self = props.context;
    menu.onHide = function () {
      if ($.isFunction(props.onHide)) props.onHide();
    };
    var copyItem = menu.getItemById('CopyLink');
    if (copyItem) {
      var dd;
      copyItem.onCreate = function () { dd = this; }
      menu.onShow = function () {
        if ($.isFunction(props.onShow)) props.onShow();
      }
    }
  };

  // Получает элементы контекстного меню для массовых операций в зависимости от переданных типов (если типы разные то, будет вычислятся пересечения пунктов меню).
  function getMassMenuItemsByTypes(types) {
    var resultMenuItems = [];
    var resultMenuItemsId = []; // для упрощения поиска

    _.each(types, function (type) {
      var menuType;
      switch (type) {
        case OBJECT_TYPE.EDOCUMENT: menuType = 'MassEDocument'; break;
        case OBJECT_TYPE.FOLDER: menuType = 'MassFolder'; break;
        case OBJECT_TYPE.TASK: menuType = 'MassTask'; break;
        case OBJECT_TYPE.JOB: menuType = 'MassJob'; break;
        case OBJECT_TYPE.REFERENCE_RECORD: menuType = 'MassReferenceRecord'; break;
        default: return;
      }

      var settings = contextMenuSettings[menuType];
      if (!settings) return;
      var currentItems = settings.items.slice(0); //Клонируем массив, чтобы сохранить его в первозданном виде.

      var newResultMenuItems = [];
      var newResultMenuItemsId = []; // для упрощения поиска
      
      const agentIsDisabled = WA.agent.isDisabled();
      const agentItems = ['SendMail'];

      var checkMenuItem = function (currentItem) {
        // Если еще нет объединенного результируешего меню, то добавим все.
        // или Если элемент меню уже был добавлен в результирующий, то добавим текущий элемент к новому результирующему.
        return (resultMenuItemsId.length === 0 || resultMenuItemsId.indexOf(currentItem.id) !== -1) && 
          !(agentIsDisabled && agentItems.includes(currentItem.id));
      };

      _.each(currentItems, function (currentItem) {
        if (checkMenuItem(currentItem)) {
          newResultMenuItems.push(currentItem);
          newResultMenuItemsId.push(currentItem.id);
        }

      });

      resultMenuItems = newResultMenuItems;
      resultMenuItemsId = newResultMenuItemsId;
    });

    return resultMenuItems;
  };

  // Выделяет тот, по которому кликнули и снимает выделения с остальных (если кликнутый элемент не в числе выделенных).
  function selectClickedElementAndUnselectOther(jClickedEl) {
    if (!jClickedEl.hasClass('List')) {
      jClickedEl = jClickedEl.parents('.List:first');
    }
    var clickedId = jClickedEl.attr('id');

    var selectedItems = WA.CR.objectList.getSelectedItems();
    var hasClicked = _.any(selectedItems, function (selectedItem) {
      return selectedItem.id === clickedId;
    });

    if (!hasClicked) {
      // Снимаем выделение со всех остальных.
      WA.CR.objectList.deselectAll();
      // Выделяем кликнутый.
      WA.CR.objectList.selectItem({ id: clickedId });
    }
  };

  function showContextMenuInternal(menu, el, coords) {
    enableDisableItems(menu, el);
    if (!coords) menu.show(el);
    else menu.showAt(coords, null, null);
  }

  function enableDisableItems(menu, el) {
    let menuItem;
    if (!Core.contextmenu.isElementInFolderTree(el) && Core.toolBars.main.isSearchMode()) {
      menuItem = menu.getItemById('CutLink');
      if (menuItem) {
        menuItem.disabled = true;
        delete menuItem.jsaction;
      }
      menuItem = menu.getItemById('DeleteLink');
      if (menuItem) {
        menuItem.disabled = true;
        delete menuItem.jsaction;
      }
    }
    let objectType = WA.CR.getObjectType();
    let mode = (new WA.URL).getParam('mode');
    if ((((objectType === OBJECT_TYPE.TASK) || (objectType === OBJECT_TYPE.JOB)) && !WA.CR.Lock.IsLocked)
          || ((objectType === OBJECT_TYPE.JOB) && (WA.CR.Kind === JOB_KIND.CONTROLJOB) && (WA.CR.State === WORK_STATE.RUNNING) && (mode !=='edit'))) {
      disableItem('DeleteLink', menu);
    } else {
      enableItem('DeleteLink', menu);
    }

    menuItem = menu.getItemById('PasteLink');
    if (menuItem) {
      menuItem.disabled = menu.type === 'Attachments' && !$('div [name=PasteLnk]').length;
    }
  }

  function showReferenceContextMenu(menu, el, coords) {
    var menuItem;
    if (g_IsReferenceReadOnly) {
      menuItem = menu.getItemById("Delete");
      if (menuItem) {
        menuItem.disabled = true;
        delete menuItem.jsaction;
      }

      menuItem = menu.getItemById("Copy");
      if (menuItem) {
        menuItem.disabled = true;
        delete menuItem.jsaction;
      }
    }
    if (!coords) menu.show(el); else menu.showAt(coords, null, null);
  }

  // Удаляет элемент по ID из массива объектов.
  function deleteItemById(items, id) {
    var newItems = [];
    for (var i = 0; i < items.length; i++) {
      //Здесь умышленно не стоит !==, для работы со строками (т.е. "id" == id)
      if (items[i].id != id) {
        newItems.push(items[i]);
      }
      else {
        if (items[i].separator && i > 0) {
          items[i - 1].separator = true;
        }
      }
    }
    return newItems;
  }

  function updateContextMenu(objType) {
    var settings = contextMenuSettings[objType];

    var changedItems = switchItemsForAgent(settings);
    if (WA.getLocation() !== 'explorer') {
      changedItems = deleteItemById(changedItems, 'CutLink');
    }
    menusCache[objType] = new ContextMenu(changedItems, settings.settings);
  }

  function switchItemsForAgent(settings) {
    var changedItems = settings.items;
    // Убираем действия, только если включена работа без агента.
    if (WA.agent.isDisabled()) {
      changedItems = deleteItemById(changedItems, 'OpenForEdit');
      changedItems = deleteItemById(changedItems, 'ViewInEditor');
      changedItems = deleteItemById(changedItems, 'SendMail');
      if ($.ipad || WA.ENV.isAndroid()) { changedItems = deleteItemById(changedItems, 'Sign'); }
    }

    return changedItems;
  }

  function disableItem(itemID, menu) {
    var menuItem = menu.getItemById(itemID);
    if (menuItem) {
      menuItem.disabled = true;
    }
  }

  function enableItem(itemID, menu) {
    var menuItem = menu.getItemById(itemID);
    if (menuItem) {
      menuItem.disabled = false;
    }
  }
  function setDefaultItem(menu, itemID) {
    var menuItem = !!itemID ? menu.getItemById(itemID) : menu.items[0];
    if (!!menuItem) {
      menuItem['default'] = true;
    }
  }

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Проверяет находится ли переденный элемент в дереве папок.
 * @function Core.contextmenu.isElementInFolderTree
 * @since 5.0.0.1516
 * @return {Core.contextmenu}
 */
  global.isElementInFolderTree = function (el) {
    return (el && el.parents('#Tree').length > 0);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Событие создания пункта контекстного меню "Копировать ссылку" для папки.
  * @function Core.contextmenu.copyFolderLinkOnCreate
  * @since 5.0.0.1519
  * @return {Core.contextmenu}
  */
  global.copyFolderLinkOnCreate = function (fol) {
    //Нельзя отправлять копировать ссылку на папку "Ярлыки" - запрещено в билдере получение по ИД этой папки (http://directum.npo-comp.ru/reference.asp?sys=TEHKASNPO&compcode=%C7%C7%CF&id=5664818).
    if (fol instanceof jQuery || fol instanceof HTMLElement) {
      var jFol = fol.tr.hasClass('List') ? fol.tr : fol.tr.children();
      return { disabled: jFol.hasClass('ShortcutsFolderType') };
    } else {
      return (fol.hasOwnProperty('canCopy')) ? { disabled: !fol.canCopy } : {};
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  *  Делает неактивным пункт "Вставить ссылки" в режиме поиска.
  */
  global.pasteLinksOnCreate = function () {
    return {
      disabled: Core.toolBars.main.isSearchMode()
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Событие создания пункта контекстного меню "Вставить ссылки" для папки.
  * @function Core.contextmenu.pasteLinksToFolderOnCreate
  * @since 5.0.0.1516
  * @return {Core.contextmenu}
  */
  global.pasteLinksToFolderOnCreate = function (fol) {
    //Проверка возможности вставки ссылок в папку fol.
    //Нельзя вставлять в папки поиска.
    var disabled;
    var visibility = (WA.getLocation() === 'settings') ? 'hidden' : '';
    if (fol instanceof jQuery || fol instanceof HTMLElement) {
      var jFol = fol.tr.hasClass('List') ? fol.tr : fol.tr.children();
      disabled = Core.toolBars.main.isSearchMode() && !(jFol.hasClass('EDocument_fol') || jFol.hasClass('Job_fol') || jFol.hasClass('Task_fol') || jFol.hasClass('Any_fol'));
    } else {
      if (fol.hasOwnProperty('canPaste')) disabled = !fol.canPaste;
      else return { visibility: visibility };
    }

    return {
      disabled: disabled,
      visibility: visibility
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   * Действие контекстного меню "Удалить ссылку".
   * @function Core.contextmenu.deleteLinksFromFolder
   * @since 5.0.0.1516
   * @return {Core.contextmenu}
   */
  global.deleteLinksFromFolder = function (fol, callback, msg) {
    // Проверим, что fol - узел дерева папок
    if (fol.hasOwnProperty('node')) {
      let node = fol.node;

      // Получим идентификатор родительской папки
      let path = node.key.split('-');
      let currentFolderIndex = path.indexOf(node.id);
      let parentFolderId = path[currentFolderIndex + 1];

      // Отправим запрос на удаление папки
      let deleteFolderLink = new WA.Link(node.id, OBJECT_TYPE.FOLDER);
      let deleteFolderLinkModel = deleteFolderLink.toLinkModel();
      DeleteLinks(
        '',
        [deleteFolderLinkModel],
        false,
        parentFolderId,
        true,
        () => {
          WA.CR.folderTree.updateByFolderID(parentFolderId);
        },
        true
      );
    } else {
      ObjDeleteLink(fol, null, callback, msg);
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
 * Действие контекстного меню "Удалить ссылку".
 * @function Core.contextmenu.deleteLinksFromFolder
 * @since 5.0.0.1516
 * @return {Core.contextmenu}
 */
  global.handleDeleteAction = function (fol) {
    var callback = null;
    var msg = "";
    if (WA.getLocation() === "settings") {
      callback = function (link) {
        window.Core.settings.setAutoCleanFolder(link.ID, false);
      };
      msg = L('SETTINGS_SAVED');
    }

    global.deleteLinksFromFolder(fol, callback, msg);
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
   *  Событие создания пункта контекстного меню "Удалить ссылку" для папки.
   * @function Core.contextmenu.deleteLinksFromFolderOnCreate
   * @since 5.0.0.1519
   * @return {Core.contextmenu}
   */
  global.deleteLinksFromFolderOnCreate = function (fol) {
    return (fol.hasOwnProperty('canDelete')) ? { disabled: !fol.canDelete } : {};
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Событие создания пункта контекстного меню "Отправить задачей" для папки.
  * @function Core.contextmenu.sendAsTaskAttachmentForFolderOnCreate
  * @since 5.0.0.1518
  * @return {Core.contextmenu}
  */
  global.sendAsTaskAttachmentForFolderOnCreate = function (fol) {
    //Нельзя отправлять вложением папку "Ярлыки" - запрещено в билдере получение по ИД этой папки (http://directum.npo-comp.ru/reference.asp?sys=TEHKASNPO&compcode=%C7%C7%CF&id=5664818).
    if (fol instanceof jQuery || fol instanceof HTMLElement) {
      var jFol = fol.tr.hasClass('List') ? fol.tr : fol.tr.children();
      return { disabled: jFol.hasClass('ShortcutsFolderType') };
    } else {
      return (fol.hasOwnProperty('canSend')) ? { disabled: !fol.canSend } : {};
    }
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Событие создания пункта контекстного меню "Создать и вложить".
  * @function Core.contextmenu.createAndAttachOnCreate
  * @since 5.0.0.1522
  * @return {Core.contextmenu}
  */
  global.createAndAttachOnCreate = function () {

    var jAttachmentsToolbar = $("#content_list_toolbox");
    var isDisabled = true;

    if (jAttachmentsToolbar.length > 0) {
      var jAttachButton = jAttachmentsToolbar.find(".add_attachment_button");

      if (jAttachButton.length > 0)
        isDisabled = jAttachButton.hasClass("disabled");
    }

    return {
      disabled: isDisabled
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Создание контекстного меню для контейнера main главной страницы.
   *
  * @function Core.contextmenu.createFolderContextMenu
  * @since 5.2.0.2006
  */
  global.createFolderContextMenu = () => {
    const jMainContainer = $('#main_container');
    jMainContainer.attr('kind', 'com');
    jMainContainer.bind('contextmenu', (event) => {
      // внутри может оказаться контейнер ошибки, по клике на него меню не нужно
      if (event.target.classList.contains('error_div_msg')) {
        return false;
      }

      event.preventDefault();
      event.stopPropagation();
      ShowContextMenu(jMainContainer, {}, {
        'left': event.pageX,
        'top': event.pageY,
      }, true);

      return false;
    });
  };

  /**
  * Клик по пункту контекстного меню "Показать/скрыть папки в списке".
  * @function Core.contextmenu.showFolderInList
  * @since 5.5.0.9000
  * @return {Core.contextmenu}
  */
  global.showFolderInList = function () {
    var currentNeedToShow = WA.CR.objectList.isShowFolders();
    var currentFolderID = WA.current.getID();

    WA.SRV.call("/Session.asmx/UpdateShowFoldersInList", {
      FolderID: currentFolderID,
      NeedToShow: !currentNeedToShow
    }).success(function (result) {
      WA.CR.objectList.setIsShowFolders(!currentNeedToShow);
      WA.CR.objectList.loadFolderContent(currentFolderID);
    });
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Событие создания пункта контекстного меню "Показать/скрыть папки в списке".
  * @function Core.contextmenu.showFolderInList
  * @since 5.5.0.9000
  * @return {Core.contextmenu}
  */
  global.showFolderInListOnCreate = function () {
    var isShowFolders = WA.CR.objectList.isShowFolders();
    return {
      selected: isShowFolders,
      image: isShowFolders ? '/App_Sprites/menu_check.png' : ''
    };
  };
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core.contextmenu);
